module.exports = "varying vec4 vColor;\nvoid main() {\n\n  gl_FragColor = vColor;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./scripts/elements/ParticlesPreloader/fragment.glsl
// module id = 209
// module chunks = 0